'use client'

import { createContext, useContext } from 'react'

interface OrderContextType {
  order: Commercetools.Order | null
}

interface OrderProviderProps {
  children: React.ReactNode
  order: Commercetools.Order | null
}

export const OrderContext = createContext<OrderContextType>({
  order: null,
})

export function OrderProvider({ children, order }: OrderProviderProps) {
  return <OrderContext.Provider value={{ order }}>{children}</OrderContext.Provider>
}

export function useOrderContext() {
  const context = useContext(OrderContext)
  return {
    order: context.order ?? null,
  }
}
